export type IconsProps = {
  className: string;
  fontSize?: number;
  color?: string;
  fw?: number;
};
export const Icons: React.FC<IconsProps> = ({
  className,
  fontSize,
  color,
  fw
}) => {
  return <i className={className} style={{
    fontSize,
    color,
    fontWeight: fw
  }} />;
};